module.exports = __webpack_public_path__ + "img/fragile.2b604e25.png";